import { ProductAccess } from '../models/product-access.model';

export type PostLoginDestination = 'planning' | 'picker' | 'projections';

export function getPostLoginDestination(productAccess?: ProductAccess): PostLoginDestination {
  if (productAccess?.hasPlanning && productAccess.hasProjections) {
    return 'picker';
  }
  if (!productAccess?.hasPlanning && productAccess?.hasProjections) {
    return 'projections';
  }
  return 'planning';
}

/**
 * The header logo opens the platform picker. Its Tax Projections card calls
 * handoff-to-projections, which returns 403 for a firm without Projections access.
 * So the logo uses the same backend hasProjections value as the login picker.
 */
export function canOpenPlatformPicker(productAccess?: ProductAccess): boolean {
  return productAccess?.hasProjections === true;
}
